import { executeIndexedDbRequest } from '../indexeddb/indexeddb';
import type { AsyncStorageEngine } from '../types/storage-engine.interface';

export class IndexedDbStorageEngine implements AsyncStorageEngine {
	public async getAsync<T = unknown>(key: string): Promise<T | null> {
		try {
			const value = await executeIndexedDbRequest<unknown>(
				'readonly',
				(store) => {
					return store.get(key) as IDBRequest<unknown>;
				}
			);

			if (typeof value !== 'string') {
				return null;
			}

			return JSON.parse(value) as T;
		} catch {
			return null;
		}
	}

	public async setAsync<T = unknown>(key: string, value: T): Promise<void> {
		try {
			const serialized = JSON.stringify(value);

			await executeIndexedDbRequest<IDBValidKey>('readwrite', (store) => {
				return store.put(serialized, key) as IDBRequest<IDBValidKey>;
			});
		} catch {
			/* noop */
		}
	}

	public async removeAsync(key: string): Promise<void> {
		try {
			await executeIndexedDbRequest<undefined>('readwrite', (store) => {
				return store.delete(key) as IDBRequest<undefined>;
			});
		} catch {
			/* noop */
		}
	}
}
